// * ========================================================================
// * Local / Session storage functionality
// * ========================================================================

const storage = (function() {

    /**
     * Check if storage exists
     *
     * @param {bool} session - use session storage or not
     * @return {bool} is storage available or not
     */
    function exists(session = false) {
        const mod = 'test';
        try {
            if (session) {
                sessionStorage.setItem(mod, mod);
                sessionStorage.removeItem(mod);
            } else {
                localStorage.setItem(mod, mod);
                localStorage.removeItem(mod);
            }

            return true;
        } catch(e) {
            return false;
        }
    }

    /**
     * Remove data
     *
     * @param {string} key - local storage key
     * @param {bool} session - use session storage or not
     */
    function removeData(key, session = false) {
        if(key && exists(session)) {
            if (session) {
                sessionStorage.removeItem(key);
            } else {
                localStorage.removeItem(key);
            }
        }
    }

    /**
     * Get localstorage data
     *
     * @param {string} key - storage key
     * @param {bool} session - use session storage or not
     * @return {object} data - localstorage data
     */
    function getData(key, session = false) {
        let data = null;

        if(key && exists(session)) {
            if (session) {
                data = sessionStorage.getItem(key);
            } else {
                data = localStorage.getItem(key);
            }

            try {
                data = data ? JSON.parse(data) : null;
            } catch(e) {
                data = null;
            }
        }

        return data;
    }

    /**
     * Update localstorage data
     *
     * @param {string} key - storage key
     * @param {object} newData - data to be updated
     * @param {bool} session - use session storage or not
     * @return {object} newData - data to be saved
     */
    function updateData(key, newData, session = false) {
        if (key) {
            let data = newData;
            // If data type is object, update only assigned values
            if (typeof newData === 'object' && !Array.isArray(newData)) {
                data = getData(key, session);
                data = data ? Object.assign(data, newData) : newData;
            }
            saveData(key, data, session);

            return data;
        }

        return null;
    }

    /**
     * Save localstorage data
     *
     * @param {string} key - localstorage key
     * @param {string} data - data to be saved
     * @param {bool} session - use session storage or not
     * @return {object} data - data to be saved
     */
    function saveData(key, data, session = false) {
        if(exists(session)) {
            if (session) {
                sessionStorage.setItem(key, JSON.stringify(data));
            } else {
                localStorage.setItem(key, JSON.stringify(data));
            }

            return true;
        }

        return false;
    }

    return {
        exists,
        getData,
        updateData,
        removeData
    }

})();

export default storage;
